<template>
  <div class="disc-trans">
    <div class="margin-general">
      <div class="container">
        <div class="img_">
          <NuxtImg
            :src="imageSrc"
            alt="Imagen decorativa plataforma"
            width="621"
            height="442"
            format="webp"
            quality="85"
            loading="lazy"
            decoding="async"
          />
          <span class="visually-hidden"></span>
        </div>
        <div class="descript_">
          <h2>{{ $t("platforms.titleDiscov") }}</h2>
          <p class="body-4">{{ $t("platforms.descriptDiscov1") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useNuxtApp } from '#app';

const { locale } = useI18n();
const { $regulationsVar } = useNuxtApp();

const config = {
  'LATAM': {
    image: '/images/platform/05.Platforms-Img2-mx.png',
  },
  'es': {
    image: '/images/platform/05.Platforms-Img2-mx.png',
  },
  'default': {
    image: '/images/platform/Platforms-Img2.png',
  }
};

const currentRegulation = computed(() => $regulationsVar.getRegulation(locale.value));

const imageSrc = computed(() => {
  return config[locale.value]?.image || config[currentRegulation.value]?.image || config['default'].image;
});
</script>